import { FC, ReactNode } from 'react'

import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

export const Countdown = styled.span`
  color: ${({ theme }) => theme.color.mediumRed};
  font-family: 'Segoe UI';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  width: 45px;
`

export const Container = styled.div`
  position: relative;
  margin-top: 8px;
  background-color: ${({ theme }) => theme.color.hoverWhite};
  padding: 24px;
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    margin-top: 0;
    padding: 12px 16px;
    font-size: 12px;

    width: 100%;
  }
`

export const GreenText = styled.span`
  color: ${({ theme }) => theme.color.brandGreen};
`

export const Arrow = styled.span`
  position: absolute;
  right: calc(50% - 9px);
  top: unset;
  bottom: -8px;
  transform: rotate(180deg);
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid ${({ theme }) => theme.color.hoverWhite};
`

type Props = {
  countdown?: string
  children: ReactNode
}

export const CheckoutBonusTooltip: FC<Props> = ({ countdown, children }) => {
  if (!countdown) {
    return null
  }
  return (
    <Container>
      <Countdown>{countdown}</Countdown>
      <span>{children}</span>
      <Arrow />
    </Container>
  )
}
